import { render, staticRenderFns } from "./FollowupChips.vue?vue&type=template&id=02265d4a&scoped=true"
import script from "./FollowupChips.vue?vue&type=script&lang=ts"
export * from "./FollowupChips.vue?vue&type=script&lang=ts"
import style0 from "./FollowupChips.vue?vue&type=style&index=0&id=02265d4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02265d4a",
  null
  
)

export default component.exports